import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCollectionsToolPanel extends Layout {
    buttonCallHistory: Button;
    buttonReports: Button;
    buttonReprintBalanceDue: Button;
    buttonReprintFreightBill: Button;
    panelButtons: Panel;
    panelToolLeft: Panel;
    panelToolRight: Panel;
}
